import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link, useNavigate } from "react-router-dom";
import { createCertification, uploadCertificationMaster } from "../../../actions/admin/certification/certification_action";
import { certificationMasterList } from "../../../actions/admin/certification/certification_master_action";
import AppBody from "../../components/AppBody";
import CertficationMasterModel from "./CertficationMasterModel";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";

const CreateCertification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //const state = useSelector((state) => state.courseReducer);
  const state = useSelector((state) => state.certificationReducer);
  const stateCerMaster = useSelector(
    (state) => state.certificationMasterReducer
  );
  // Call Course and MOdule list API here page load time
  
  const [showValidation, setShowValidation] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    //setUser({ is_file: true });
    const formData = new FormData();
    formData.append("file", data.file[0]);
    dispatch(uploadCertificationMaster(formData));
  };

  useEffect(() => {
    dispatch(certificationMasterList());
  }, []);

  const [show, setShow] = useState(false);
  const [popupTitile, setPopupTitle] = useState("");
  const [type, setType] = useState("");

  const clickOnAdd = (act, type) => {
    setPopupTitle(act);
    setShow(true);
    setType(type);
  };

  const resetPopup = () => {
    setPopupTitle("");
    setShow(false);
    setType("");
    dispatch(certificationMasterList());
  };

  const [certification, setCertification] = useState({
    name: "",
    level: "",
    certification_type: "",
    product: "",
    exam: "",
    certification_role: "",
    certification_details: "",
    remark: "",
    role: "",
    cost_doller: "",
    cost_inr: "",
    exam_link: "",
    recommended_experiance: 0,
  });

  const submitCertification = (e) => {
    e.preventDefault();
    dispatch(createCertification(certification));
  };

  let roles = [],
    certificationTypes = [],
    certificationRoles = [],
    products = [],
    exams = [];
  if (stateCerMaster.list) {
    certificationTypes = stateCerMaster.list.filter(
      (obj) => obj.type === "CertificationType"
    );
    certificationRoles = stateCerMaster.list.filter(
      (obj) => obj.type === "CertificationRoles"
    );
    roles = stateCerMaster.list.filter((obj) => obj.type === "RolesType");
    products = stateCerMaster.list.filter((obj) => obj.type === "Product");
    exams = stateCerMaster.list.filter((obj) => obj.type === "Exam");
  }
  
  if (state.is_done) {
      navigate("/certification/list");
  }

  const handleClose = () => {
    setShowValidation(false);
    //setUser({ is_file: false });
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link to={"/all-courses"} className="d-inline-block mt-2">
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Create Certification
                </h4>
              </div>
              {show && (
                <CertficationMasterModel
                  show={show}
                  type={type}
                  title={popupTitile}
                  handelUpdateShow={() => resetPopup()}
                />
              )}


              {showValidation ? (
                <Modal show={showValidation} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Errors</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="err-model-body">
                    {state.errors &&
                      state.errors.map((li, i) => (
                        <h4 key={i} className={"error-msg"}>
                          {"Row " +
                            li.row +
                            " " +
                            li.attribute +
                            " " +
                            li.errors}{" "}
                        </h4>
                      ))}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              ) : (
                <div />
              )}


              <div className="card-body  p-4 w-100 border-0 ">
                <form
                  enctype="multipart/form-data"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div class="alert alert-success">
                    <strong>
                      Please note, you can use the bulk upload for certification
                      add
                    </strong>
                  </div>
                  <h1 className="text-white">Import Excel </h1>
                  <div className={"row"}>
                    <div className="col-lg-6 mb-2">
                      <label className="mont-font fw-600 font-xsss">
                        Upload File
                      </label>
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          accept=".xls, .xlsx"
                          {...register("file", { required: true })}
                        />
                        <label class="custom-file-label" htmlFor="customFile">
                          Choose file
                        </label>

                        <span className="error-msg">
                          {state.errors.other_error
                            ? state.errors.other_error
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="submit"
                        name="submit"
                        value="Upload"
                        className="btn-common px-5 mt-30"
                      />
                      <a
                        className="btn-common px-5 mt-30 temp-btn"
                        // href={templte}
                        download
                        title={"Doownload excel file template"}
                        style={{ margin: "4px", padding: "12.5px" }}
                      >
                        <i class="fa fa-download"></i>
                        Download
                      </a>
                    </div>
                    <div className="col-lg-3"></div>
                  </div>
                </form>
                <br />

                <form
                  enctype="multipart/form-data"
                  onSubmit={submitCertification}
                >
                  <div className="row">
                    <div className="col-lg-8 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.name ? state.errors.name : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Level
                        </label>
                        <select
                          className="form-control"
                          name={"level"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              level: e.target.value,
                            })
                          }
                        >
                          <option value={""}> Select Level</option>
                          <option value={"Beginner"} key={"Beginner"}>
                            Beginner
                          </option>
                          <option value={"Intermediate"} key={"Intermediate"}>
                            Intermediate
                          </option>
                          <option value={"Advance"} key={"Advance"}>
                            Advance
                          </option>
                        </select>
                        <span className="error-msg">
                          {state.errors.course_id ? state.errors.course_id : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Type
                        </label>
                        <select
                          className="form-control"
                          name={"certification_type"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_type: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select Certification Type</option>
                          {certificationTypes &&
                            certificationTypes.map((li, i) => (
                              <option value={li.id} key={i + 1}>
                                {li.name}
                              </option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.certification_type
                            ? state.errors.certification_type
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add New"
                        onClick={() =>
                          clickOnAdd("Certification Type", "CertificationType")
                        }
                        className="btn-common px-3 mt-30"
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Product
                        </label>
                        <select
                          className="form-control"
                          name={"product"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              product: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select Product</option>
                          {products &&
                            products.map((li, i) => (
                              <option key={i + 1} value={li.id}>
                                {li.name}
                              </option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.product ? state.errors.product : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        onClick={() => clickOnAdd("Product", "Product")}
                        value="Add New"
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Role
                        </label>
                        <select
                          className="form-control"
                          name={"role"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              role: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select Role Type</option>
                          {roles &&
                            roles.map((li, i) => (
                              <option value={li.id} key={i + 1}>
                                {li.name}
                              </option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.role ? state.errors.role : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add New"
                        onClick={() => clickOnAdd("Role Type", "RolesType")}
                        className="btn-common px-3 mt-30"
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Exam
                        </label>
                        <select
                          className="form-control"
                          name={"exam"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              exam: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select Exam</option>
                          {exams &&
                            exams.map((li, i) => (
                              <option key={i + 1} value={li.id}>
                                {li.name}
                              </option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.exam ? state.errors.exam : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        onClick={() => clickOnAdd("Exam", "Exam")}
                        value="Add New"
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Role
                        </label>
                        <select
                          className="form-control"
                          name={"certification_role"}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_role: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Certification Role</option>
                          {certificationRoles &&
                            certificationRoles.map((li, i) => (
                              <option key={i + 1} value={li.id}>
                                {li.name}
                              </option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.certification_role
                            ? state.errors.certification_role
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        onClick={() =>
                          clickOnAdd(
                            "Certification Roles",
                            "CertificationRoles"
                          )
                        }
                        value="Add New"
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Recommended Experience
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              recommended_experiance: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.recommended_experiance
                            ? state.errors.recommended_experiance
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cost($)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.cost_doller}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              cost_doller: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.cost_doller
                            ? state.errors.cost_doller
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-3 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cost(INR)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.cost_inr}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              cost_inr: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.cost_inr ? state.errors.cost_inr : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Exam Link
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={certification.exam_link}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              exam_link: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.exam_link ? state.errors.exam_link : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-7 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certification Description
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={2}
                          cols={4}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              certification_description: e.target.value,
                            })
                          }
                        >
                          {" "}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.certification_description
                            ? state.errors.certification_description
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-5 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Remark
                        </label>
                        <textarea
                          name="description"
                          className="form-control"
                          rows={2}
                          cols={4}
                          onChange={(e) =>
                            setCertification({
                              ...certification,
                              remark: e.target.value,
                            })
                          }
                        >
                          {" "}
                        </textarea>
                        <span className="error-msg">
                          {state.errors.remark ? state.errors.remark : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <input
                        type="submit"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CreateCertification;
